import React from 'react'

import clsx from 'clsx'
import { Box, Typography } from '@material-ui/core'

import usePrimaryBannerPreview from 'hooks/usePrimaryBannerPreview'

import styles from './styles'

const BannerDescription = () => {
  const {
    previewTexts,
    descriptionRef,
    isDescriptionExpanded,
    isDescriptionOverflowing,
    isCompact,
  } = usePrimaryBannerPreview()

  const useStyles = styles(isCompact)
  const classes = useStyles()

  return (
    <Box position="relative" width="100%">
      <Typography
        ref={descriptionRef}
        className={clsx(classes.globalTypography, {
          [classes.descriptionClamped]: !isDescriptionExpanded,
          [classes.descriptionExpanded]: isDescriptionExpanded,
        })}
      >
        {previewTexts.description}
      </Typography>
      {!isDescriptionExpanded && isDescriptionOverflowing && (
        <div className={classes.descriptionFade} />
      )}
    </Box>
  )
}

export default BannerDescription
